import service from '@/request/service';

export const cinemaCurrencySign = (set, get) => {
  return {
    cinemaCurrencySign: null,
    seatSpliceRuleInfo: null,
    fetchCinemaCurrencySign: async (key: any, wapid, cinemaId) => {
      // 检查缓存数据是否已存在且与当前 key 匹配
      const currentData = get().filmData;
      if (currentData && currentData.key === key) {
        // 如果已存在且匹配，不需要重新获取数据
        return;
      }
      try {
        // 假设有一个函数 fetchDataFromAPI 来获取数据
        if (wapid && cinemaId) {
          const { result } = await service.getCinemaCurrencySign({
            channelCode: wapid,
            cinemaLinkId: cinemaId,
          });
          const seatSpliceRuleInfo = result?.bizValue?.filter((item) => {
            return item.cinemaLinkId === cinemaId;
          })[0]?.seatSpliceRuleInfo;

          set({ cinemaCurrencySign: { key, value: result?.bizValue } });
          set({ seatSpliceRuleInfo: { key, value: seatSpliceRuleInfo } });
        }
      } catch (error) {
        console.error('获取数据失败', error);
      } finally {
        // 无论成功还是失败，最后都将 loading 状态设置为 false
      }
    },
  };
};
